import { DEV_MODE } from '@/config/dev-mode';

const { VITE_WEB_BASE_URL } = import.meta.env;
const THUMBNAIL_URL = `${VITE_WEB_BASE_URL}/secure/snsDefault.png`;

export const branchShareDataMap = {
  notice: {
    titlePrefix: `[낭만만세력] `,
    messagePreset: `[낭만만세력] 공지사항 공유해요!`,
  },
  word: {
    titlePrefix: `[낭만만세력] `,
    messagePreset: `[낭만만세력] 사주 활용법 공유해요!`,
  },
  event: {
    titlePrefix: `[낭만만세력] `,
    messagePreset: `[낭만만세력] 이벤트 공유해요!`,
  },
  essay: {
    titlePrefix: `[낭만만세력] `,
    messagePreset: `[낭만만세력]\n낭만에세이 공유해요!`,
  },
  faq: {
    titlePrefix: `[낭만만세력] `,
    messagePreset: `[낭만만세력] 자주 묻는 질문 공유해요!`,
  },
  default: {
    titlePrefix: `[낭만만세력] `,
    messagePreset: `[낭만만세력] 콘텐츠를 공유해요!`,
  },
};

/** 낭만센터 path를 앱 내 게시판명으로 변환 */
export const convertPathToBranchPage = (path) => {
  if (path.startsWith('/nangman-center/notice')) return 'notice';
  if (path.startsWith('/nangman-center/word')) return 'word';
  if (path.startsWith('/nangman-center/event')) return 'event';
  if (path.startsWith('/nangman-center/essay')) return 'essay';
  if (path.startsWith('/essay')) return 'essay';
  if (path.startsWith('/nangman-center/faq')) return 'faq';
  return null;
};

/** Branch 링크 생성 */
export const createBranchLink = async (data) => {
  const { contentId, page, contentTitle, login, routePath, imageUrl } = data;

  const baseUrl = DEV_MODE ? 'https://d25web.thegam.io' : VITE_WEB_BASE_URL;
  const deeplinkQuery = `screen=${page}&articleId=${contentId}`;

  const linkProps = {
    data: {
      // 앱 내 branch 리스너 형식에 맞게 작성되었음
      // $canonical_identifier: `?screen=${page}&articleId=${contentId}`,
      // $og_title: `${branchShareDataMap[page].titlePrefix}${contentTitle}`,
      // $og_image_url: login && imageUrl ? imageUrl : THUMBNAIL_URL,
      // $deeplink_path: `?screen=${page}&articleId=${contentId}`,
      // $custom_url: `nangmanshare://open?screen=${page}&articleId=${contentId}`,
      // $fallback_url: `https://nangmancalendar.com/${routePath}`,

      // 1) 정규 식별자: 쿼리 대신 경로로
      $canonical_identifier: `?screen=${page}&articleId=${contentId}`,

      // 2) UL/AppLink 진입 경로(앱 내부 라우터에서 파싱)
      $deeplink_path: `open?${deeplinkQuery}`,

      // 3) 인앱 브라우저 강제 앱오픈(플랫폼 분리 권장)
      // $ios_custom_url: `nangmanshare://open?${deeplinkQuery}`,
      // $android_custom_url: `nangmanshare://open?${deeplinkQuery}`,

      // 4) 데스크톱 폴백은 desktop_url, 모바일/실패 폴백은 fallback_url
      // $desktop_url:  `${baseUrl}${routePath}`,
      // $fallback_url:  `${baseUrl}${routePath}`,
      // $fallback_url: `nangmanshare://open?${deeplinkQuery}`,

      // 5) 어트리뷰션 태그 (공유 경로에 맞게 동적 지정)
      '~channel': 'KakaoTalk',
      '~feature': 'share',

      // 6) 미리보기
      $og_title: `${
        (branchShareDataMap[page] || branchShareDataMap.default).titlePrefix
      }${contentTitle}`,
      $og_image_url: login && imageUrl ? imageUrl : THUMBNAIL_URL,
    },
  };

  const url = await generateLink(linkProps);

  return url;
};

const generateLink = (linkProps) => {
  return new Promise((resolve, reject) => {
    branch.link(linkProps, (err, link) => {
      if (err) {
        reject(err);
      } else {
        resolve(link);
      }
    });
  });
};

export const modifyEssayContent = (messageLength, item) => {
  let content = '';
  if (item.firstTitle) content += `\n\n${item.firstTitle}`;
  if (item.secondTitle) content += `\n\n${item.secondTitle}`;
  if (item.thirdTitle) content += `\n\n${item.thirdTitle}`;
  if (item.fourthTitle) content += `\n\n${item.fourthTitle}`;
  if (item.contents) content += replaceEssayContentTag(`\n\n${item.contents}`);
  if (content.length + messageLength > 500)
    content = content.substring(0, 500 - messageLength - 6) + '...';
  return content;
};

export const replaceEssayContentTag = (contents) => {
  if (!contents) return '';
  return (
    contents
      // 줄바꿈 대체용 태그는 \n으로
      .replace(/<(div|p|br)[^>]*>/gi, '')
      .replace(/<\/(div|p)>/gi, '\n')

      // 인라인 스타일 태그는 제거 (span, strong, em 등)
      .replace(/<(span|strong|em|b|i)[^>]*>/gi, '')
      .replace(/<\/(span|strong|em|b|i)>/gi, '')

      // 이미지 태그 제거
      .replace(/<img[^>]*>/gi, '')

      // &nbsp; 제거
      .replace(/&nbsp;/gi, ' ')

      // 그 외 남은 HTML 태그 제거
      .replace(/<[^>]+>/g, '')

      // 연속된 줄바꿈 정리 (선택적)
      .replace(/\n{2,}/g, '\n\n') // 2줄 이상은 2줄로
      .trim()
  );
};
